import { ReactElement, useMemo } from "react";
import styles from "./NameAndPronouns.module.less";
import { UserIdentityModel, UserStatus } from "client/Api/UserProfile/service";
import { localize } from "client_legacy/ndaw/culture";
import { getIdentifiesAs } from "../Settings/UserProfile/UserProfileForm";
import { isNotNil, setTrackingId } from "client/Misc/utils";
import classNames from "classnames";

export type NameAndPronounsProps = {
	authorUserInfo: UserIdentityModel;
	nameSize?: "default" | "small";
};

export const NameAndPronouns = (props: NameAndPronounsProps): ReactElement => {
	const {
		authorUserInfo,
		nameSize = "default"
	} = props;

	const identifiesAs = useMemo(
		(): string | null => {
			if (authorUserInfo.status === UserStatus.Inactive
				|| authorUserInfo.status === UserStatus.Deleted
			) {
				return localize("_InactiveUser");
			}

			return getIdentifiesAs(authorUserInfo.pronouns);
		},
		[authorUserInfo.pronouns, authorUserInfo.status]
	);

	return (
		<div className={styles.root}>
			<span
				{...setTrackingId("name")}
				className={classNames(
					styles.name,
					{
						[styles.name_small]: nameSize === "small"
					}
				)}
				title={`${authorUserInfo.firstName} ${authorUserInfo.lastName}`}
			>
				{authorUserInfo.firstName} {authorUserInfo.lastName}
			</span>
			{isNotNil(identifiesAs) && (
				<span
					{...setTrackingId("identifies-as")}
					className={styles.identifiesAs}
				>
					{identifiesAs}
				</span>
			)}
		</div>
	);
};
NameAndPronouns.displayName="NameAndPronouns";